import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b49710f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-title"]

import { onBeforeMount, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Template000 from './template/Template-000.vue';
import Template001 from './template/Template-001.vue';
import Template002 from './template/Template-002.vue';
import Template003 from './template/Template-003.vue';
import Template004 from './template/Template-004.vue';
import TemplateRequest from '../data/TemplateRequest';
import { TemplateStyle } from '../data/TemplateData';
import AbilityParamsUtil from '../bridge/AbilityParamsUtil';


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessComponent',
  setup(__props) {

const templateStyle = ref<TemplateStyle>(TemplateStyle.TemplateStyle000);
const { t } = useI18n();

const viewKey = ref<string>('');

const title = ref(t('common.wpsOffice'));

function isStyle001() {
  return templateStyle.value === TemplateStyle.TemplateStyle001;
}

function isStyle002() {
  return templateStyle.value === TemplateStyle.TemplateStyle002;
}

function isStyle003() {
  return templateStyle.value === TemplateStyle.TemplateStyle003;
}

function isStyle004() {
  return templateStyle.value === TemplateStyle.TemplateStyle004;
}

onBeforeMount(() => {
  viewKey.value = AbilityParamsUtil.getViewKey();
  var shareObj = AbilityParamsUtil.getShareObj();
  var shareContent = shareObj.share_content;
  if (
    shareContent !== undefined &&
    shareContent != null &&
    shareContent.title != undefined &&
    shareContent.title != ''
  ) {
    title.value = shareContent.title;
  }
  templateStyle.value = TemplateRequest.getTemplateStyle(viewKey.value);
});

return (_ctx: any,_cache: any) => {
  const _directive_title = _resolveDirective("title")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "root",
    "data-title": title.value
  }, [
    (isStyle001())
      ? (_openBlock(), _createBlock(Template001, {
          key: 0,
          view_key: viewKey.value
        }, null, 8, ["view_key"]))
      : (isStyle002())
        ? (_openBlock(), _createBlock(Template002, {
            key: 1,
            view_key: viewKey.value
          }, null, 8, ["view_key"]))
        : (isStyle003())
          ? (_openBlock(), _createBlock(Template003, {
              key: 2,
              view_key: viewKey.value
            }, null, 8, ["view_key"]))
          : (isStyle004())
            ? (_openBlock(), _createBlock(Template004, {
                key: 3,
                view_key: viewKey.value
              }, null, 8, ["view_key"]))
            : (_openBlock(), _createBlock(Template000, { key: 4 }))
  ], 8, _hoisted_1)), [
    [_directive_title]
  ])
}
}

})